/**
 * @typedef {Object} BreadcrumbItem
 * @property {string} text -パンくずに表示されるタイトル
 * @property {string} link - パンくずのページURL
 */

/**
 *
 * @param {string} title ページタイトル
 * @param {string} description ページデスクリプション
 * @param {BreadcrumbItem[]} breadCrumb パンくずリスト
 *
 */

export function useCustomJsonld(breadCrumb) {
  const config = useRuntimeConfig()
  const hostDomain = `${config.public.hostDomain}`

  useJsonld(() => (
    [{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'item': {
            '@id': `${config.public.hostDomain}`,
            'name': 'トップ'
          }
        },
        ...breadCrumb.map((item, index) => {
          return {
            '@type': 'ListItem',
            'position': index + 2,
            'item': {
              ...(item.link ? { '@id': new URL(`${hostDomain}${item.link}`) } : {}),
              name: item.text
            }
          }
        })
      ]
    }
    ]
  ))
}
